import { useState } from "react";
import { Check } from './icons';
const CopyCell = ({ children, v, c }) => {
  const [ok, setOk] = useState(false);
  return (
    <td style={{
      padding: "10px 12px", fontVariantNumeric: "tabular-nums",
      textAlign: "right", cursor: "pointer", fontSize: 13,
      color: ok ? c.blue : c.fg, transition: "color 0.15s",
    }} onClick={() => {
      navigator.clipboard?.writeText?.(String(v ?? children));
      setOk(true); setTimeout(() => setOk(false), 700);
    }}>
      {ok ? <Check size={12} /> : children}
    </td>
  );
};
export const Table = ({ h, r, c }) => (
  <div style={{ overflowX: "auto", borderRadius: 12, border: "1px solid " + c.border }}>
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
      <thead>
        <tr style={{ borderBottom: "1px solid " + c.border, background: c.card2 }}>
          {h.map((x, i) => (
            <th key={i} style={{
              padding: "10px 12px", textAlign: i ? "right" : "left",
              fontWeight: 600, color: c.muted, fontSize: 11,
              letterSpacing: "0.06em", textTransform: "uppercase", whiteSpace: "nowrap",
            }}>{x}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {r.map((row, i) => (
          <tr key={i} className="wm-trow" style={{ borderBottom: i < r.length - 1 ? "1px solid " + c.border : "none", transition: "background 0.1s" }}>
            {row.map((x, j) =>
              j === 0
                ? <td key={j} style={{ padding: "10px 12px", fontWeight: 500, fontSize: 13, color: c.fg, whiteSpace: "nowrap" }}>{x}</td>
                : <CopyCell key={j} v={x} c={c}>{x}</CopyCell>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
